module.exports = __webpack_public_path__ + "media/images/bg-pattern2-a03f5025a9426a0f19cda1fc7af02eb2.png";